import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: '#0a0a0b',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99999,
            padding: '20px',
            boxSizing: 'border-box',
            textAlign: 'center',
          }}
        >
          <h1
            style={{
              fontFamily: "'Cormorant', serif",
              fontSize: 'clamp(32px, 4.5vw, 54px)',
              fontWeight: 400,
              color: '#c9a86a',
              margin: '0 0 16px',
              lineHeight: 1.2,
            }}
          >
            Something went wrong.
          </h1>
          <p
            style={{
              fontFamily: "'Hanken Grotesk', sans-serif",
              fontSize: '16px',
              fontWeight: 300,
              color: '#8b8579',
              margin: '0 0 24px',
            }}
          >
            Please reload the page.
          </p>
          <button
            type="button"
            className="kny-ghost"
            onClick={() => window.location.reload()}
            style={{
              background: 'transparent',
              color: '#ece7dd',
              border: '1px solid rgba(201,168,106,0.4)',
              padding: '14px 28px',
              font: "500 11px/1 'JetBrains Mono', monospace",
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              cursor: 'pointer',
              borderRadius: '2px',
            }}
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
